import { ITreatmentList } from 'app/api/treatment/model'
import R from 'app/assets/R'
import { flatMap } from 'lodash'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { SeeMoreButton, ServiceText } from '../styles'

interface IProps {
  data: ITreatmentList[]
}
export const TreatmentList = (props: IProps) => {
  const { data } = props
  const { t } = useTranslation()

  const [isCollapse, setIsCollapse] = useState(true)

  const onCollapseClick = () => {
    setIsCollapse(true)
  }
  const onSeeMoreClick = () => {
    setIsCollapse(false)
  }

  return isCollapse ? (
    <>
      <ServiceText
        children={data[0]?.data && `1. ${data[0]?.data[0]?.name}`}
        textAlign="left"
        fontSize='xxs'
      />
      {flatMap(data, 'data')?.length > 1 && (
        <SeeMoreButton
          children={t(R.strings.see_more)}
          onClick={onSeeMoreClick}
        />
      )}
    </>
  ) : (
    <>
      {data?.map((item, index) => (
        <>
          {item?.data?.map(i => (
            <>
              <ServiceText
                children={`${index + 1}. ${i?.name}`}
                textAlign="left"
                fontSize='xxs'
              />
            </>
          ))}
        </>
      ))}
      {flatMap(data, 'data')?.length > 1 && (
        <SeeMoreButton
          children={t(R.strings.collapse)}
          onClick={onCollapseClick}
        />
      )}
    </>
  )
}
